/* eslint-disable unused-imports/no-unused-vars */

import cuentasContables from './cuentasContables'
import informes from './informes'
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        modulos: [],

        alias: [],
        trasacciones: [],
        fechaM: null,
        fechaMax: null,
        maestroCuenta: [],
        estadoCuenta: [],
        reportePlanCuenta: [],
        PlanCuentas: [],
        exportarDiario: [],
        CodigosTransaccion: [],
        CargarCodigosTransaccion: [],
        RegistroContable: [],
        SecuencialTransaccion: [],
        ImportarDiario: [],
        tipoMovimiento: [],
        grupoMovimiento: [],
        procesos: [],
        dataCierreContable: [],
        dataUtilidadPerdidAnual: [],
        mayorMensual: [],
        ProcesoAll: [],
        EstablecimientoCont: [],
        GrupoMovimientoAll: [],
        TipoMovimientoAll: [],
        detalleCierreContable: [],
        PlanCuentaActivo: [],
        ObtenerCierreMesPeriodo: [],
        ExisteCuentaContable: [],
        CargarGrupoMovimiento: [],
        CargarProceso: [],
        AllCuentasContables: [],
        AllCentroCosto: [],
        AllSubcentroCosto: [],
        PermisosCCSC: [],
        ModuloTransaccional: [],
        ProcesoByModulo: [],
        SubprocesoByProceso: [],
        SecuencialBySubproceso: [],
        EstablecimientosByPermiso: [],
        AllPersonas: [],
        existeEstablecimiento: [],
        UnidadNegocio: [],
        DiarioGeneral: [],
        MayorGeneral: [],
        EstadoPyG: [],
        Anexo: [],
        AnexoActivosFijos: [],
        MovimientosContables: [],
        CargarDatosDiarioApertura: [],
        ImprimirTransaccion: [],
        MaestrosCuenta: [],
        AllPlanCuentas: [],
    },
    getters: {
        getModulos(state) {
            return state.modulos
        },
        getAlias(state) {
            return state.alias
        },
        getTransacciones(state) {
            return state.trasacciones
        },
        getFechaMax(state) {
            return state.fechaM
        },
        getFechaMaxN(state) {
            return state.fechaMax
        },
        getMaestroCuenta(state) {
            return state.maestroCuenta
        },
        getEstadoCuenta(state) {
            return state.estadoCuenta
        },
        getReportPlanCuenta(state) {
            return state.reportePlanCuenta
        },
        getPlanCuentas(state) {
            return state.PlanCuentas
        },
        getExportarDiario(state) {
            return state.exportarDiario
        },

        getRegistroContable(state) {
            return state.RegistroContable
        },
        getCodigosTransaccion(state) {
            return state.CodigosTransaccion
        },
        getTipoMovimiento(state) {
            return state.tipoMovimiento
        },
        getGrupoMovimiento(state) {
            return state.grupoMovimiento
        },
        getProceso(state) {
            return state.procesos
        },
        getDataCierreContable(state) {
            return state.dataCierreContable
        },

        getSecuencialTransaccion(state) {
            return state.SecuencialTransaccion
        },
        getImportarDiario(state) {
            return state.ImportarDiario
        },

        getProcesoAll(state) {
            return state.ProcesoAll
        },
        getEstablecimientoCont(state) {
            return state.EstablecimientoCont
        },
        getGrupoMovimientoAll(state) {
            return state.GrupoMovimientoAll
        },
        getTipoMovimientoAll(state) {
            return state.TipoMovimientoAll
        },

        getPlanCuentaActivo(state) {
            return state.PlanCuentaActivo
        },

        getObtenerCierreMesPeriodo(state) {
            return state.ObtenerCierreMesPeriodo
        },

        getExisteCuentaContable(state) {
            return state.ExisteCuentaContable
        },
        getCargarGrupoMovimiento(state) {
            return state.CargarGrupoMovimiento
        },
        getCargarProceso(state) {
            return state.CargarProceso
        },

        getAllCuentasContables(state) {
            return state.AllCuentasContables
        },

        getAllCentroCosto(state) {
            return state.AllCentroCosto
        },

        getAllSubcentroCosto(state) {
            return state.AllSubcentroCosto
        },

        getPermisosCCSC(state) {
            return state.PermisosCCSC
        },

        getModuloTransaccional(state) {
            return state.ModuloTransaccional
        },

        getProcesoByModulo(state) {
            return state.ProcesoByModulo
        },

        getSubprocesoByProceso(state) {
            return state.SubprocesoByProceso
        },

        getSecuencialBySubproceso(state) {
            return state.SecuencialBySubproceso
        },

        getEstablecimientosByPermiso(state) {
            return state.EstablecimientosByPermiso
        },

        getAllPersonas(state) {
            return state.AllPersonas
        },

        existeEstablecimiento(state) {
            return state.existeEstablecimiento
        },

        getUnidadNegocio(state) {
            return state.UnidadNegocio
        },

        getEstablecimientosByUnidadNegocio(state) {
            return state.EstablecimientosByUnidadNegocio
        },

        /**REPORTERIA CONTABILIDAD ---------------------------------------------------------------------------------------------------- */

        getDiarioGeneral(state) {
            return state.DiarioGeneral
        },

        getMayorGeneral(state) {
            return state.MayorGeneral
        },
        getMayorProcesos(state) {
            return state.MayorProcesos
        },
        getEstadoPyG(state) {
            return state.EstadoPyG
        },
        getEstadoFinancieroSegmentado(state) {
            return state.EstadoFinancieroSegmentado
        },
        getAnexo(state) {
            return state.Anexo
        },
        getAnexoActivosFijos(state) {
            return state.AnexoActivosFijos
        },
        getMovimientosContables(state) {
            return state.MovimientosContables
        },

        /**REPORTERIA CONTABILIDAD ---------------------------------------------------------------------------------------------------- */

        getCargarDatosDiarioApertura(state) {
            return state.CargarDatosDiarioApertura
        },

        getImprimirTransaccion(state) {
            return state.ImprimirTransaccion
        },

        getMaestrosCuenta(state) {
            return state.MaestrosCuenta
        },

        getAllPlanCuentas(state) {
            return state.AllPlanCuentas
        },
    },

    mutations: {
        setModulos(state, modulos) {
            state.modulos = modulos
        },
        setTipoMovimiento(state, tipoMovimiento) {
            state.tipoMovimiento = tipoMovimiento
        },
        setGrupoMovimiento(state, grupoMovimiento) {
            state.grupoMovimiento = grupoMovimiento
        },
        setProceso(state, procesos) {
            state.procesos = procesos
        },
        setAlias(state, alias) {
            state.alias = alias
        },
        setTrasaccion(state, trasacciones) {
            state.trasacciones = trasacciones
        },
        setFechaM(state, fechaM) {
            state.fechaM = fechaM
        },
        setFechaMax(state, fechaMax) {
            state.fechaMax = fechaMax
        },
        setMaestroCuenta(state, maestroCuenta) {
            state.maestroCuenta = maestroCuenta
        },
        setEstadoPlanCuenta(state, estadoCuenta) {
            state.estadoCuenta = estadoCuenta
        },
        setReportePlanCuenta(state, reportePlanCuenta) {
            state.reportePlanCuenta = reportePlanCuenta
        },
        set_PlanCuentas(state, PlanCuentas) {
            state.PlanCuentas = PlanCuentas
        },

        set_ExportarDiario(state, exportarDiario) {
            state.exportarDiario = exportarDiario
        },

        set_CargarCodigosTransaccion(state, CodigosTransaccion) {
            state.CodigosTransaccion = CodigosTransaccion
        },
        setDataCierreContable(state, dataCierreContable) {
            state.dataCierreContable = dataCierreContable
        },
        setDataUtilidadPerdidAnual(state, dataUtilidadPerdidAnual) {
            state.dataUtilidadPerdidAnual = dataUtilidadPerdidAnual
        },
        setMayorMensual(state, mayorMensual) {
            state.mayorMensual = mayorMensual
        },
        setRegistroContable(state, RegistroContable) {
            state.RegistroContable = RegistroContable
        },

        setSecuencialTransaccion(state, SecuencialTransaccion) {
            state.SecuencialTransaccion = SecuencialTransaccion
        },
        setImportarDiario(state, ImportarDiario) {
            state.ImportarDiario = ImportarDiario
        },

        setDetalleCierreContable(state, detalleCierreContable) {
            state.detalleCierreContable = detalleCierreContable
        },
        setPlanCuentaActivo(state, PlanCuentaActivo) {
            state.PlanCuentaActivo = PlanCuentaActivo
        },

        setObtenerCierreMesPeriodo(state, ObtenerCierreMesPeriodo) {
            state.ObtenerCierreMesPeriodo = ObtenerCierreMesPeriodo
        },

        setExisteCuentaContable(state, ExisteCuentaContable) {
            state.ExisteCuentaContable = ExisteCuentaContable
        },

        setProcesoAll(state, ProcesoAll) {
            state.ProcesoAll = ProcesoAll
        },

        setEstablecimientoCont(state, EstablecimientoCont) {
            state.EstablecimientoCont = EstablecimientoCont
        },
        setGrupoMovimientoAll(state, GrupoMovimientoAll) {
            state.GrupoMovimientoAll = GrupoMovimientoAll
        },
        setTipoMovimientoAll(state, TipoMovimientoAll) {
            state.TipoMovimientoAll = TipoMovimientoAll
        },
        setCargarGrupoMovimiento(state, CargarGrupoMovimiento) {
            state.CargarGrupoMovimiento = CargarGrupoMovimiento
        },
        setCargarProceso(state, CargarProceso) {
            state.CargarProceso = CargarProceso
        },

        setAllCuentasContables(state, AllCuentasContables) {
            state.AllCuentasContables = AllCuentasContables
        },

        setAllCentroCosto(state, AllCentroCosto) {
            state.AllCentroCosto = AllCentroCosto
        },

        setAllSubcentroCosto(state, AllSubcentroCosto) {
            state.AllSubcentroCosto = AllSubcentroCosto
        },

        setPermisosCCSC(state, PermisosCCSC) {
            state.PermisosCCSC = PermisosCCSC
        },

        setModuloTransaccional(state, ModuloTransaccional) {
            state.ModuloTransaccional = ModuloTransaccional
        },

        setProcesoByModulo(state, ProcesoByModulo) {
            state.ProcesoByModulo = ProcesoByModulo
        },

        setSubprocesoByProceso(state, SubprocesoByProceso) {
            state.SubprocesoByProceso = SubprocesoByProceso
        },

        setSecuencialBySubproceso(state, SecuencialBySubproceso) {
            state.SecuencialBySubproceso = SecuencialBySubproceso
        },

        setEstablecimientosByPermiso(state, EstablecimientosByPermiso) {
            state.EstablecimientosByPermiso = EstablecimientosByPermiso
        },

        setAllPersonas(state, AllPersonas) {
            state.AllPersonas = AllPersonas
        },

        setUnidadNegocio(state, UnidadNegocio) {
            state.UnidadNegocio = UnidadNegocio
        },

        setEstablecimientosByUnidadNegocio(state, EstablecimientosByUnidadNegocio) {
            state.EstablecimientosByUnidadNegocio = EstablecimientosByUnidadNegocio
        },

        /**REPORTERIA CONTABILIDAD ---------------------------------------------------------------------------------------------------- */

        setDiarioGeneral(state, DiarioGeneral) {
            state.DiarioGeneral = DiarioGeneral
        },

        setMayorGeneral(state, MayorGeneral) {
            state.MayorGeneral = MayorGeneral
        },
        setMayorProcesos(state, MayorProcesos) {
            state.MayorProcesos = MayorProcesos
        },
        setEstadoPyG(state, EstadoPyG) {
            state.EstadoPyG = EstadoPyG
        },
        setEstadoFinancieroSegmentado(state, EstadoFinancieroSegmentado) {
            state.EstadoFinancieroSegmentado = EstadoFinancieroSegmentado
        },
        setBalanceDinamico(state, BalanceDinamico) {
            state.BalanceDinamico = BalanceDinamico
        },
        setBalanceSegmentado(state, BalanceDinamico) {
            state.BalanceDinamico = BalanceDinamico
        },
        setAnexo(state, Anexo) {
            state.Anexo = Anexo
        },
        setAnexoActivosFijos(state, Anexo) {
            state.Anexo = Anexo
        },

        /**REPORTERIA CONTABILIDAD ---------------------------------------------------------------------------------------------------- */

        setCargarDatosDiarioApertura(state, CargarDatosDiarioApertura) {
            state.CargarDatosDiarioApertura = CargarDatosDiarioApertura
        },

        setCuentaAjustePatrimonio(state, CuentaAjustePatrimonio) {
            state.CuentaAjustePatrimonio = CuentaAjustePatrimonio
        },

        setImprimirTransaccion(state, ImprimirTransaccion) {
            state.ImprimirTransaccion = ImprimirTransaccion
        },

        setMaestrosCuenta(state, MaestrosCuenta) {
            state.MaestrosCuenta = MaestrosCuenta
        },

        setAllPlanCuentas(state, AllPlanCuentas) {
            state.AllPlanCuentas = AllPlanCuentas
        },
        setMovimientosContables(state, MovimientosContables) {
            state.MovimientosContables = MovimientosContables
        },
    },
    actions: {
        fetchFechaM({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/fechaMax')
                    .then(response => {
                        commit('setFechaM', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async actualizarClaseDeCuenta({ commit }, data) {
            return (await axios.post(`/api/auth/contabilidad/actualizar-clase-cuenta`, data)).data
        },
        fetchCentrosCostos({ commit }, params) {
            return axios.get('/api/auth/contabilidad/centro-costos', { params })
        },
        fetchPostCentroCostos({ commit }, data) {
            return axios.post('/api/auth/contabilidad/centro-costos', data)
        },
        fetchUpdateCentroCostos({ commit }, data) {
            return axios.put(`/api/auth/contabilidad/centro-costos/${data.id_centro_costo}`, data)
        },
        fetchDesactivarCentroCostos({ commit }, data) {
            return axios.delete(`/api/auth/contabilidad/centro-costos/${data.id_centro_costo}`)
        },
        fetchSubCentrosCostos({ commit }, params) {
            return axios.get('/api/auth/contabilidad/centro-costos/subcentros', { params })
        },
        fetchPostSubCentroCostos({ commit }, data) {
            return axios.post('/api/auth/contabilidad/centro-costos/subcentros', data)
        },
        fetchUpdateSubCentroCostos({ commit }, data) {
            return axios.put(`/api/auth/contabilidad/centro-costos/subcentros/${data.id_subcentro_costo}`, data)
        },
        fetchDesactivarSubCentroCostos({ commit }, data) {
            return axios.delete(`/api/auth/contabilidad/centro-costos/subcentros/${data.id_subcentro_costo}`)
        },
        fetchDetalleCierre({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/detalleCierreContable', { params: data })
                    .then(response => {
                        commit('setDetalleCierreContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDataCierreContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/dataCierreContable', { params: data })
                    .then(response => {
                        commit('setDataCierreContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDataUtilidadPerdidAnual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/utilidad-perdida-anual', { params: data })
                    .then(response => {
                        commit('setDataUtilidadPerdidAnual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postUtilidadPerdidAnual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/utilidad-perdida-anual', { params: data })
                    .then(response => {
                        commit('setDataUtilidadPerdidAnual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postMayorizacionMensual({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/mayorizacion/mensual', { params: data })
                    .then(response => {
                        commit('setMayorMensual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMayorizacionPatrominio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/mayor/anual', { params: data })
                    .then(response => {
                        commit('setMayorMensual', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFechaMax({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/fechaMaxN')
                    .then(response => {
                        commit('setFechaMax', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModulos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/modulos')
                    .then(response => {
                        commit('setModulos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPostmodulo({ commit }, data) {
            // return axios.post('/api/auth/contabilidad/crear-modulo', data)
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/modulo/crear-modulo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdatemodulo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/contabilidad/modulo/${data.id_modulo}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPostProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/modulo/crear-proceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateproceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/contabilidad/modulo/${data.id_proceso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPostSubProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/modulo/crear-SubProceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdatesubproceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/contabilidad/modulo/${data.id_subproceso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarUsuario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/agregarUsuario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchUpdateDataCierreContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/updateDataCierreContable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAlias({ commit }, data) {
            return new Promise((resolve, reject) => {
                let url = '/api/auth/contabilidad/alias'
                if (data.Id) {
                    url += `?Id=${data.Id}`
                }
                if (data.Usuario) {
                    url += `?Usuario=${data.Usuario}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setAlias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                let url = '/api/auth/contabilidad/trasaccion'
                if (data.Id) {
                    url += `?Id=${data.Id}`
                }
                if (data.codigo) {
                    url += `?codigo=${data.codigo}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setTrasaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoMovimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                let url = '/api/auth/contabilidad/tipoMovimiento'
                if (data.Id) {
                    url += `?Id=${data.Id}`
                }
                if (data.codigo) {
                    url += `?descripcion=${data.codigo}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setTipoMovimiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGrupoMovimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                let url = '/api/auth/contabilidad/grupoMovimiento'
                if (data.Id) {
                    url += `?Id=${data.Id}`
                }
                if (data.codigo) {
                    url += `?descripcion=${data.codigo}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setGrupoMovimiento', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGrupoMovimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/aperturaGrupoMovimiento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postTipoMovimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/aperturaTipoMovimiento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/aperturaProceso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                let url = '/api/auth/contabilidad/procesos'
                if (data.Id) {
                    url += `?Id=${data.Id}`
                }
                if (data.codigo) {
                    url += `?descripcion=${data.codigo}`
                }
                axios
                    .get(url)
                    .then(response => {
                        commit('setProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postCierreAbsoluto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/cierre', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCierreAbsoluto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/cierreContable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchClaseCuenta({ commit }, targetId) {
            return (await axios.get(`/api/auth/contabilidad/clase-cuenta/${targetId}`)).data
        },
        async guardarClaseDeCuenta({ commit }, data) {
            return (await axios.post('/api/auth/contabilidad/clase-cuenta', data)).data
        },

        async desactivarClasePlanDeCuenta({ commit }, targetId) {
            return (await axios.delete(`/api/auth/contabilidad/clase-cuenta/${targetId}`)).data
        },
        async fetchCuentasContables({ commit }, params) {
            const response = await axios.get('/api/auth/contabilidad/cuentas-contables', { params })
            return response
        },
        async fetchAllRegistroPlanCuenta({ commit }, params) {
            return (await axios.get('/api/auth/contabilidad/plan-cuenta/registros/all', { params })).data
        },
        async guardarCuentaContable({ commit }, data) {
            return (await axios.post('/api/auth/contabilidad/plan-cuenta/registro', data)).data
        },
        async actualizarRegistroPlanCuenta({ commit }, { targetId, data }) {
            return (await axios.put(`/api/auth/contabilidad/plan-cuenta/registros/${targetId}`, data)).data
        },
        async desactivarRegistroPlanCuenta({ commit }, id) {
            return (await axios.delete(`/api/auth/contabilidad/plan-cuenta/registros/${id}`)).data
        },
        async borrarRegistroPlanCuenta({ commit }, id) {
            return (await axios.delete(`/api/auth/contabilidad/plan-cuenta/borrar-registro/${id}`)).data
        },
        async fetchMaestroCuentasContables({ commit }, params) {
            const maestros = await axios.get('/api/auth/contabilidad/cuentas-contables/maestros', { params })
            commit('setMaestroCuenta', maestros.data)
            return maestros
        },
        async fetchEstadoPlanCuenta({ commit }) {
            const response = await axios.get('/api/auth/contabilidad/plan-cuenta/estadoPlanCuenta')
            commit('setEstadoPlanCuenta', response.data)
            return response
        },
        fetchReportePlanCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/plan-cuenta/reportePlanCuenta', { params: data })
                    .then(response => {
                        commit('setReportePlanCuenta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async fetchEstadosPlanCuenta({ commit }) {
            return (await axios.get('/api/auth/contabilidad/plan-cuenta/estados')).data
        },
        async fetchMaestrosPlanCuenta({ commit }) {
            return (await axios.get('/api/auth/contabilidad/plan-cuenta/numero-cuenta')).data
        },
        async fetchClasesCuentas({ commit }, params) {
            const response = await axios.get('/api/auth/contabilidad/cuentas-contables/clases', { params })
            return response
        },
        async getArbolCuentasByPlan({ commit }, { id_plan_cuenta, params }) {
            const response = await axios.get(`/api/auth/contabilidad/plan-cuentas/${id_plan_cuenta}/arbol-cuentas`, {
                params,
            })
            return response
        },
        // fetchReportePlanCuenta({ commit }, data) {
        //   return new Promise((resolve, reject) => {
        //     axios.get('/api/auth/contabilidad/plan-cuenta/reportePlanCuenta', { params: data })
        //         .then((response) => {
        //             commit('setReportePlanCuenta', response.data)
        //             resolve(response)

        //         })
        //         .catch((error) => {
        //             reject(error);
        //         })
        // })

        // },
        // MAESTRO PLAN DE CUENTAS
        fetchCuentasMaestras({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/CuentasMaestras')
                    .then(response => {
                        commit('set_CuentasMaestras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCrearPlanCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/CrearPlanCuenta', data)
                    .then(response => {
                        // commit('set_CuentasMaestras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateMasivoPlanesCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/UpdateMasivoPlanesCuenta', data)
                    .then(response => {
                        // commit('set_CuentasMaestras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // SE CREAN EN MASIVO LAS CUENTAS CONTABLES UNA VEZ SE CREA UN NUEVO PLAN DE CUENTA
        fetchCreateCuentasContables({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/CreateCuentasContables', data)
                    .then(response => {
                        // commit('set_CuentasMaestras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchPlanCuentas({ commit }, params) {
            const response = await axios.get('/api/auth/contabilidad/plan-cuentas', { params })
            commit('set_PlanCuentas', response.data)
            return response
        },
        // Alejandro Barreiro
        fetchExportarDiario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/exportarDiario', data)
                    .then(response => {
                        // commit('set_ExportarDiario', response.data.datosExcel)
                        resolve(response.data.datosExcel)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReplicarPlanCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/ReplicarPlanCuenta', data)
                    .then(response => {
                        // commit('set_CuentasMaestras', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCargarCodigosTransaccion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/CargarCodigosTransaccion')
                    .then(response => {
                        commit('set_CargarCodigosTransaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getRegistroContable', { params: data })
                    .then(response => {
                        commit('setRegistroContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSecuencialTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getSecuencialTransaccion', { params: data })
                    .then(response => {
                        commit('setSecuencialTransaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // codigo transaccion
        fetchProcesoAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getProcesoAll', { params: data })
                    .then(response => {
                        commit('setProcesoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstablecimientoCont({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getEstablecimientoCont', { params: data })
                    .then(response => {
                        commit('setEstablecimientoCont', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postUpdateProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/UpdateProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEliminarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/EliminarProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postModificarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/ModificarProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        PostImportarDiaio({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/ImportarDiario')
                    .then(response => {
                        resolve(response.data.datosExcel)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistrarContabilidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/registrarContabilidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGrupoMovimientoAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getGrupoMovimientoAll', { params: data })
                    .then(response => {
                        commit('setGrupoMovimientoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipoMovimientoAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/getTipoMovimientoAll', { params: data })
                    .then(response => {
                        commit('setTipoMovimientoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAgregarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/AgregarProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchActualizarDiario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/ActualizarDiario', data)
                    .then(response => {
                        resolve(response.data.datosExcel)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async descargarPlantillaCuentasContables({ commit }) {
            return (
                await axios.get('/api/auth/contabilidad/cuentas-contables/plantilla', {
                    responseType: 'arraybuffer',
                })
            ).data
        },

        fetchPlanCuentaActivo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/PlanCuentaActivo')
                    .then(response => {
                        commit('setPlanCuentaActivo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUpdateSecuencialTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/UpdateSecuencialTransaccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAnularTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/AnularTransaccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchObtenerCierreMesPeriodo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/ObtenerCierreMesPeriodo', { params: data })
                    .then(response => {
                        commit('setObtenerCierreMesPeriodo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExisteCuentaContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/ExisteCuentaContable', { params: data })
                    .then(response => {
                        commit('setExisteCuentaContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCargarProceso({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/CargarProceso')
                    .then(response => {
                        commit('setCargarProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/EliminarProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/AgregarProceso', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        async updateCuentasContablesMasivo(_, data) {
            const response = await axios.post('/api/auth/contabilidad/plan-cuenta/cuentas-contables', data)
            return response
        },

        fetchAllCuentasContables({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/cuentas-contables-all', { params: data })
                    .then(response => {
                        commit('setAllCuentasContables', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllCentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/centro-costo-all', { params: data })
                    .then(response => {
                        commit('setAllCentroCosto', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllSubcentroCosto({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/subcentro-costo-all', { params: data })
                    .then(response => {
                        commit('setAllSubcentroCosto', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPermisosCCSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/administracion/permisos-ccsc', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPermisosCCSC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoCentroCosto(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-ccsc/centro-costo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postPermisoSubCentroCosto(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/administracion/permisos-ccsc/subcentro-costo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModuloTransaccional({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/modulo-all', { params: data })
                    .then(response => {
                        commit('setModuloTransaccional', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchProcesoByModulo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/proceso-by-modulo', { params: data })
                    .then(response => {
                        commit('setProcesoByModulo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSubprocesoByProceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/subproceso-by-proceso', { params: data })
                    .then(response => {
                        commit('setSubprocesoByProceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSecuencialBySubproceso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/secuencial-by-subproceso', { params: data })
                    .then(response => {
                        commit('setSecuencialBySubproceso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstablecimientosByPermiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/establecimientos-by-permiso', { params: data })
                    .then(response => {
                        commit('setEstablecimientosByPermiso', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllPersonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/personas-all', { params: data })
                    .then(response => {
                        commit('setAllPersonas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExisteEstablecimiento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/existe-establecimiento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExisteCC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/existe-cc', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExisteSC({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/existe-sc', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchExistePersona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/existe-persona', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchImportarDiario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/ImportarDiario', data)
                    .then(response => {
                        commit('setProcesoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/unidad-negocio', { params: data })
                    .then(response => {
                        commit('setUnidadNegocio', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstablecimientosByUnidadNegocio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/establecimiento-by-unidad-negocio', { params: data })
                    .then(response => {
                        commit('setEstablecimientosByUnidadNegocio', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /**
         * REPORTERIA CONTABILIDAD
         */
        fetchUpdateContabidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/updateContabilidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDiarioGeneral({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/diario-general', { params: data })
                    .then(response => {
                        commit('setDiarioGeneral', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMayorGeneral({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/mayor-general', { params: data })
                    .then(response => {
                        commit('setMayorGeneral', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchMayorProcesos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/mayor-procesos', { params: data })
                    .then(response => {
                        commit('setMayorProcesos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEstadoPyG({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/estado-perdida-ganancia', { params: data })
                    .then(response => {
                        commit('setEstadoPyG', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCostosEmpacadoras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/costos-empacadoras', { params: data })
                    .then(response => {
                        commit('setEstadoPyG', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCostosTilapieras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/costos-tilapieras', { params: data })
                    .then(response => {
                        commit('setEstadoPyG', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEstadoFinancieroSegmentado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/estado-financiero-segmentado', { params: data })
                    .then(response => {
                        commit('setEstadoFinancieroSegmentado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBalanceDinamico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/balance-dinamico', { params: data })
                    .then(response => {
                        commit('setBalanceDinamico', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBalanceComprobacionSegmentado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/balance-comprobacion-segmentado-por-mes', { params: data })
                    .then(response => {
                        commit('setBalanceSegmentado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnexo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/anexo', { params: data })
                    .then(response => {
                        commit('setAnexo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnexoActivosFijos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/anexo-activos-fijos', { params: data })
                    .then(response => {
                        commit('setAnexoActivosFijos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMovimientosContables({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/consulta-movimientos-contables', { params: data })
                    .then(response => {
                        commit('setMovimientosContables', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCargarDatosDiarioApertura({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/cargar-datos-diario-apertura', { params: data })
                    .then(response => {
                        commit('setCargarDatosDiarioApertura', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postAperturaContableModulo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/apertura-contable-modulo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Cierre Contable v2
        fetchCierreContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/obtener-cierre-contable', { params: data })
                    .then(response => {
                        commit('setDataCierreContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDetalleCierrexMes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/obtener-detalle-mes', { params: data })
                    .then(response => {
                        commit('setDataCierreContable', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postCierreContable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/cierre-contable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCuentaAjustePatrimonio({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/cuenta-ajuste-patrimonio', { params: data })
                    .then(response => {
                        commit('setCuentaAjustePatrimonio', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGenerarDiarioApertura({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/contabilidad/generar-diario-apertura', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchImprimirTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/imprimir-transaccion', { params: data })
                    .then(response => {
                        commit('setImprimirTransaccion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Export Excel
        fetchExportarDiarioExcel({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/exportar-excel', { params: data })
                    .then(response => {
                        commit('setProcesoAll', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMaestrosCuenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/maestros-cuenta', { params: data })
                    .then(response => {
                        commit('setMaestrosCuenta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllPlanCuentas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/contabilidad/all-plan-cuenta', { params: data })
                    .then(response => {
                        commit('setAllPlanCuentas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
    modules: {
        cuentasContables,
        informes,
    },
}
